import { render } from "./mat-fab-button.vue?vue&type=template&id=9768d512&scoped=true"
import script from "./mat-fab-button.vue?vue&type=script&lang=js"
export * from "./mat-fab-button.vue?vue&type=script&lang=js"

import "./mat-fab-button.vue?vue&type=style&index=0&id=9768d512&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9768d512"]])

export default __exports__